import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import { getAssetPath, getFixedSchema } from "@commonUtils"
import { useSelector } from "react-redux"

const SEO = React.memo(function SEO(props) {
    const cspNonce = useSelector((state) => state.shellReducer?.cspNonce)
    return (
        <Helmet>
            <title>{props.title}</title>
            <meta name="keywords" content={props.keywords} />
            <meta property="og:title" content={props.title} />
            <meta property="og:description" content={props.description} />
            <meta name="description" content={props.description} />
            <meta property="og:url" content={props.ogUrl} />
            <meta name="msvalidate.01" content="099F7701BE7D0B79C7C51734FDC2A2D9" />
            <meta
                name="ahrefs-site-verification"
                content="eb0267c26a6f598370b8474c41fc54fc21b4cd8609ec062ce06f47f413eea869"
            />
            {props.dynamicMetaTags?.length &&
                props.dynamicMetaTags?.map((metaTagInfo, index) => {
                    return <meta name={metaTagInfo.name} content={metaTagInfo.content} key={index} />
                })}
            {/* Social SEO tags */}
            <meta property="fb:app_id" content={props.fbApp_id} />
            <meta property="og:site_name" content="1mg" />
            <meta property="og:image" content={getAssetPath("site-icons/1mg-logo-large.png")} />
            <meta property="twitter:card" content="summary" />
            <meta property="twitter:site" content="@1mgofficial" />
            <meta property="twitter:domain" content="1mg.com" />
            <meta property="twitter:title" content={props.title} />
            <meta property="twitter:description" content={props.description} />
            <link rel="canonical" href={props.canonical}></link>
            <link rel="publisher" href="https://plus.google.com/+Healthkartplus" />
            {props.alternate}
            <meta property="twitter:image" content={getAssetPath("site-icons/1mg-logo-large.png")} />
            {props.children}
            {props.schemaData && (
                <script type="application/ld+json" nonce={cspNonce}>{`${JSON.stringify(
                    props.schemaData
                )}`}</script>
            )}
            <script type="application/ld+json" nonce={cspNonce}>{`${JSON.stringify(
                getFixedSchema()
            )}`}</script>
            {props.next && <link rel="next" href={props.next}></link>}
            {props.previous && <link rel="prev" href={props.previous}></link>}
        </Helmet>
    )
})

SEO.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    description: PropTypes.string,
    ogUrl: PropTypes.string,
    canonical: PropTypes.string,
    keywords: PropTypes.string,
    alternate: PropTypes.node,
    schemaData: PropTypes.object,
    next: PropTypes.string,
    previous: PropTypes.string,
    dynamicMetaTags: PropTypes.array,
    fbApp_id: PropTypes.string,
}

SEO.defaultProps = {
    title: "Online Pharmacy India | Buy Medicines from India's Trusted Medicine Store: 1mg.com",
    description:
        "India's best online pharmacy with a wide range of Prescription and OTC medicines. Order medicines online at 1mg's medicine store in 100+ cities like - Delhi, Mumbai, Bangalore, Kolkata, Hyderabad, Gurgaon, Noida, Pune etc. with free home delivery and exciting offers. Check Now!",
    fbApp_id: "212401972496595",
    keywords:
        "online pharmacy, online medicine, medicine online, online medical store, buy medicine online, online pharmacy India, buy medicine online India, online chemist, online medicine purchase",
    ogUrl: process.env.EXTERNAL_BASE_URL,
    canonical: process.env.EXTERNAL_BASE_URL,
    dynamicMetaTags: [],
}

export default SEO
